import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';

export const selectBalconies = createSelector(selectJsonQuery, jsonQuery => getRangeValue('balconies')(jsonQuery));
